import React, { Fragment, useMemo, useState, useRef } from 'react';
import PageTitle from 'components/common/PageTitle';
import Flex from 'components/common/Flex';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Nav, Tab } from 'react-bootstrap';
import SubProbjectsWrapper from './SubProbjectsWrapper';

const Projects = () => {
  const { t } = useTranslation();
  const { new_tree } = useSelector(state => state.appsetting);

  const projectsData = useMemo(
    () =>
      new_tree?.sub_categories.find(s => s.name === 'Projects').sub_categories,
    [new_tree]
  );

  const title = 'Projects';
  const [selectedKey, setSelectedKey] = useState(projectsData[0]?._id);

  return (
    <div>
      <PageTitle title={title} />
      <div className="page-content pt-6 mb-6">
        <Tab.Container
          activeKey={selectedKey}
          onSelect={k => setSelectedKey(k)}
          id="countries-tab"
          transition={true}
        >
          <Flex justifyContent="between" alignItems="center" className="">
            <Nav variant="tabs" className="flex-row">
              {projectsData?.map((c, index) => (
                <Fragment key={index}>
                  <Nav.Item>
                    <Nav.Link eventKey={c._id} className="fw-semi-bold fs-1">
                      {t(c.name)}
                    </Nav.Link>
                  </Nav.Item>
                </Fragment>
              ))}
            </Nav>
          </Flex>
          <Tab.Content>
            {projectsData.map(c => (
              <Tab.Pane eventKey={c._id} title={c.name} className="p-3 pt-0">
                {c.content && c.content.length > 0 ? (
                  <SubProbjectsWrapper categories={c.content} />
                ) : (
                  <div className="d-flex justify-content-center w-100 mt-3">
                    <span className="f-16 fw-semi-bold">
                      No project information available at the moment
                    </span>
                  </div>
                )}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default Projects;
